import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../../helpers/helpers';
import { CustomSelectComplex } from '../../CustomSelectComplex/CustomSelectComplex';
import { Input, FormGroup, Spinner } from 'reactstrap';
import { ButtonBlue } from '../../Buttons/ButtonBlue';
import { CustomModal } from '../../CustomModal/CustomModal';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import peopleToVisitSuccessIcon from '../../../assets/icons/people-to-visit-success-icon.svg';
import PeopleToVisitManagementContext from '../../../context/PeopleToVisitContext/PeopleToVisitManagementContext';
import AccessOpeningContext from '../../../context/AccessOpeningContext/AccessOpeningContext';
import AccessBuildingContext from '../../../context/AccessBuildingContext/AccessBuildingContext';
import SectorsManagementContext from '../../../context/SectorsContext/SectorsManagementContext';

export const CreateAndEditPersonToVisit = () => {
    const navigate = useNavigate();
    const { personId } = useParams();
    const isEditing = personId;
    const idLabel = getTenantInfoByKey('contractor_id_lbl');
    const nameOfOpenings = getTenantInfoByKey('opening_name');

    const { peopleToVisitManagementState, getPeopleToVisit, removeWarningModal, createPersonToVisit, editPersonToVisit } = useContext(PeopleToVisitManagementContext);
    const { personData, peopleToVisitToConfig, isFetching, responsePeopleToVisitService } = peopleToVisitManagementState;

    const { accessOpeningState, getAccessOpenings } = useContext(AccessOpeningContext);
    const { accessOpenigs } = accessOpeningState;

    const { getAccessBuildings, accessBuildingState } = useContext(AccessBuildingContext);
    const { accessBuildings } = accessBuildingState;

    const { sectorsManagementState, getSectorsManagement } = useContext(SectorsManagementContext);
    const { sectorsToConfig } = sectorsManagementState;

    const openingsOptions = accessOpenigs.map(opening => ({ label: `${opening.codigo} - ${opening.descripcion}`, value: opening.codigo, target: { value: `${opening.codigo}`, name: 'openingCodes' } }));
    const buildingsOptions = accessBuildings.map(accessBuilding => ({ label: `${accessBuilding.opening ? accessBuilding.opening.openingDescription + ' - ' : ''}${accessBuilding.buildingCode} - ${accessBuilding.buildingDescription}`, value: accessBuilding.buildingId, opening: accessBuilding?.opening?.openingCode, target: { value: `${accessBuilding.buildingId}`, name: 'buildingIds' } }));
    const sectorsOptions = sectorsToConfig.map(sector => ({ label: `${sector.sectorName}`, value: sector.sectorId, target: { value: `${sector.sectorId}`, name: 'sectorId' } }));

    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');
    const haveAccessBuildings = getTenantInfoByKey('is_building');

    const [personDataState, setPersonDataState] = useState(personData);

    const haveBuildingOptions = buildingsOptions?.length;
    const checkOpeningWithBuilding = !haveBuildingOptions ? false : personDataState.buildingIds?.length === 0 ? true : false;

    const disabledWithOpeningAndBuilding = !!!String(personDataState.documentNumber).trim() ||
        !!!String(personDataState.name).trim() ||
        !!!String(personDataState.lastName).trim() ||
        personDataState.openingCodes?.length === 0 ||
        checkOpeningWithBuilding ||
        personDataState.sectorId === '';

    const disabledWithBuilding = !!!String(personDataState.documentNumber).trim() ||
        !!!String(personDataState.name).trim() ||
        !!!String(personDataState.lastName).trim() ||
        personDataState.buildingIds?.length === 0 ||
        personDataState.sectorId === '';

    const disabled = !!!String(personDataState.documentNumber).trim() ||
        !!!String(personDataState.name).trim() ||
        !!!String(personDataState.lastName).trim() ||
        personDataState.sectorId === '';

    const disabledButton = () => {
        if (haveAccessOpenings) {
            if (haveAccessBuildings) {
                return disabledWithOpeningAndBuilding;
            }
            return disabledWithOpeningAndBuilding;
        }
        if (haveAccessBuildings) {
            return disabledWithBuilding;
        }
        return disabled;
    }


    const nameOfBuildings = getTenantInfoByKey('building_name');

    const removeBuildingsIds = (e) => {
        console.log(e)
        if (e.length === 0) {
            return [];
        }
        const buildingsToRemove = accessBuildings.filter(building => !e.includes(building.opening.openingCode));
        const buildingsIdToRemove = buildingsToRemove.map(building => building.buildingId);
        return personDataState.buildingIds.filter(building => !buildingsIdToRemove.includes(building));
    }

    const handleChange = (e, selectName) => {

        if (selectName === 'openingCodes') {

            return setPersonDataState({ ...personDataState, openingCodes: e, buildingIds: removeBuildingsIds(e) })
        }

        if (selectName === 'buildingIds') {
            return setPersonDataState({ ...personDataState, buildingIds: e })
        }

        if (selectName === 'sectorId') {
            return setPersonDataState({ ...personDataState, sectorId: e ? Number(e.target.value) : '' })
        }

        let { value, name, checked } = e.target;

        setPersonDataState({
            ...personDataState,
            [name]: name === 'enabled' ? checked : replaceExpecialCharacters(value)
        })
    }

    const handleSubmit = async () => {
        if (disabledButton()) return
        if (personId) {
            return await editPersonToVisit(personDataState);
        }

        await createPersonToVisit(personDataState);
    }

    const closeWarningModal = async () => responsePeopleToVisitService.type === 'ERROR' ? removeWarningModal() : navigate('/settings/entityManagment/peopleToVisitMaganagement');

    const goCancel = () => navigate(-1);

    const getPersonAndloadState = async () => {
        const response = await getPeopleToVisit(personId);
        setPersonDataState(response);
    }

    useEffect(() => {
        getSectorsManagement(null, true);

        if (isEditing && peopleToVisitToConfig.length === 0) {
            getPersonAndloadState();
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {

        if (haveAccessOpenings) {
            getAccessOpenings(true);
            if (haveAccessBuildings && personDataState?.openingCodes?.length) {
                getAccessBuildings(true, personDataState.openingCodes);
            }
        } else {
            if (haveAccessBuildings) {
                getAccessBuildings(true, []);
            }

        }

        // eslint-disable-next-line
    }, [personDataState.openingCodes]);

    return (

        <div className='row justify-content-center'>
            <div className='col-xl-4 col-lg-7 col-sm-9 mt-5'>
                <div className='me-3 ms-3 mt-2'>

                    <CustomModal showModal={responsePeopleToVisitService.show} centered={true} setShowModal={closeWarningModal}>
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={responsePeopleToVisitService.type === 'ERROR' ? errorIcon : peopleToVisitSuccessIcon} alt="" />
                            <p className='mt-3 text-center param-section-title'>{responsePeopleToVisitService.text}</p>
                            <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
                        </div>
                    </CustomModal>

                    {isFetching ?
                        <div className="d-flex mt-4 justify-content-center">
                            <Spinner />
                        </div>
                        : null}

                    <div>
                        <p className='m-0 titlelabel-filter'>{idLabel}</p>
                        <p>
                            <input
                                className='form-control'
                                type="text"
                                name='documentNumber'
                                value={personDataState.documentNumber}
                                onChange={handleChange}
                                disabled={personId ? true : false}
                            />
                        </p>
                    </div>

                    <div>
                        <p className='m-0 titlelabel-filter'>{t('NAME')}</p>
                        <p>
                            <input
                                className='form-control'
                                type="text"
                                name='name'
                                value={personDataState.name}
                                onChange={handleChange}
                            />
                        </p>
                    </div>

                    <div>
                        <p className='m-0 titlelabel-filter'>{t('SURNAME')}</p>
                        <p>
                            <input
                                className='form-control'
                                type="text"
                                name='lastName'
                                value={personDataState.lastName}
                                onChange={handleChange}
                            />
                        </p>
                    </div>

                    <div className='d-flex justify-content-center'>
                        <hr
                            style={{ border: 'solid 1px #3b97f2', width: '10px' }}
                            className='m-0 opacity-100 ps-4'
                        />
                    </div>

                    {
                        haveAccessOpenings ?
                            <div className='mt-2'>
                                < label
                                    className="form-label titlelabel-filter"
                                    htmlFor="openings"
                                >
                                    {nameOfOpenings}
                                </label>

                                <CustomSelectComplex
                                    options={openingsOptions}
                                    name={'openingCodes'}
                                    placeholder={t('SELECT')}
                                    isClearable={true}
                                    isMulti
                                    value={openingsOptions.filter(op => personDataState.openingCodes.some(opening => opening === op.value))}
                                    onChange={(options) => handleChange(options.map(option => option.value), 'openingCodes')}
                                />
                            </div>
                            : null
                    }

                    {haveAccessBuildings && haveBuildingOptions ?
                        <div className='mt-2'>
                            <label
                                className="form-label titlelabel-filter"
                                htmlFor="buildings"
                            >
                                {nameOfBuildings}
                            </label>

                            <CustomSelectComplex
                                options={buildingsOptions}
                                name={'buildings'}
                                placeholder={t('SELECT')}
                                isClearable={true}
                                isMulti
                                value={buildingsOptions.filter(op => personDataState.buildingIds.some(building => building === op.value))}
                                onChange={(options) => handleChange(options.map(option => option.value), 'buildingIds')}
                            />
                        </div>
                        : null
                    }


                    <div className='mt-2'>
                        <label
                            className="form-label titlelabel-filter"
                            htmlFor="sector"
                        >
                            {t('SECTOR')}
                        </label>

                        <CustomSelectComplex
                            options={sectorsOptions}
                            value={sectorsOptions.find(options => options.value === personDataState.sectorId)}
                            name={'sectorId'}
                            placeholder={t('SELECT')}
                            isClearable={true}
                            onChange={(e) => handleChange(e, 'sectorId')}
                        />
                    </div>

                    <div className='mt-3'>
                        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '5px' }} className='p-2 d-flex justify-content-between align-items-center'>
                            <div>
                                <p className='m-0'>{personDataState.enabled ? t('ENABLED') : t('NOT_ENABLED')}</p>
                            </div>

                            <div>
                                <FormGroup switch>
                                    <Input type="switch" name='enabled' checked={personDataState.enabled} onClick={handleChange} />
                                </FormGroup>
                            </div>
                        </div>


                        <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
                            <div className=''>
                                <p type='button' className='m-0' onClick={goCancel}>{t('CANCEL')}</p>
                            </div>

                            <div className=''>
                                <ButtonBlue onClick={handleSubmit} disabled={disabledButton()}>
                                    {t('SAVE')}
                                </ButtonBlue>
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        </div >
    )
}
